<template>
	<div class="entity-select-view">
		<div v-if="label" class="edit__label">{{ label }} <span v-if="!optional">*</span></div>
		<input :style="label ? { height: '30px' } : {}" :class="(_valid !== null ? (_valid ? 'validated' : 'validated error') : '')" ref="input" type="text" @click="focus" v-model="str" @input="tap" />
	</div>
</template>

<script>
	import ContextPopupView from './ContextPopupView'
	import merge from '../functions/merge'

	export default {
		data() {
			return {
				results: [],
				timeout: null,
				str: ''
			};
		},
		props: {
			lazy: {
				type: Boolean,
				default: false
			},
			lbl: {
				type: String, 
				default: null
			},
			label: {
				type: String, 
				default: null
			},
			optional: {
				type: Boolean,
				default: false
			},
			validator: {
				type: Function,
				default: function (obj) {
					return null;
				}
			},
			create: {
				type: Function,
				default: null
			},
			labelMap: {
				type:  Function,
				default: function (obj) {
					console.log('MAP');
					return obj;
				}
			},
			descMap: {
				type:  Function,
				default: function (obj) {
					return this.labelMap(obj);
				}
			},
			clearMap: {
				type: Function,
				default: function (obj) {
					return obj;
				}
			},
			value: {
				type: Object,
				default() {
					return {};
				}
			},
			clear: {

			},
			mutable: {
				type: Boolean,
				default: false
			},
			url: {
				type: String,
				required: true
			},
			map: {
				type: Function,
				default: function (obj) {
					console.log('MAP');
					return obj;
				}
			}
		},
		watch: {
			value: {
				handler() {
					console.log('val changed');

					if (this.validator(this.value) === null || this.validator(this.value)) {
						console.log('valid', this.value);
						this.str = this.labelMap(this.value).toString();
					}
				},
				deep: true
			}
		},
		computed: {
			_valid() {
				return this.validator(this.value);
			},
			_actions() {
				var r = [];
				var self = this;	

				for (var i = 0; i < this.results.length; ++i) {
					var obj = self.map(self.results[i])	;

					console.log('hmm', obj, self.labelMap(obj));

					r.push({
						label: self.descMap(obj),
						action: (function () {
							var j = i;
							var obj = self.map(self.results[i])	;
							var completeObj = merge({}, self.results[i]);

							return function () {
								console.log(obj);

								console.log('before merge', self.value, obj);
								var m = merge(self.value, obj);
								console.log('merged', m);

								self.$emit('input', m);
								self.$emit('select', completeObj);
							}
						})()
					});
				}

				if (self.create) {
					r.push(null);
					r.push({
						label: 'Opret',
						action: function () {
							console.log('opret');
						}
					});
				}

				return r;
			}
		},
		methods: {
			focus(e) {
				e.target.select();
			},
			tap() {
				this.$store.state.popupController.close();
				
				this.$emit('input', merge(this.value, { label: this.str }));
				this.$emit('lbl:update', this.str );

				var self = this;

				clearTimeout(this.timeout);

				this.timeout = setTimeout(function () {
					self.search();
				}, 500);
			},
			search() {
				if (this.str == '') return;

				console.log('search', this.str);

				var self = this;

				this.axios
					.get(this.url + '?search=' + encodeURI(this.str))
					.then(function (r) {
						self.results = r.data._items;

						var actions = self.results.length == 0 ? (self.create ? [
							{
								label: 'Opret',
								action: function () {
									console.log('test');
								}
							}
						] : []) : self._actions;

						self.$store.state.popupController.popup(ContextPopupView, {
							anchor: self.$refs.input,
							align: 'left',
							actions: actions
						});
					});
			}
		},
		mounted() {
			if (this.validator(this.value)) {
				this.str = this.labelMap(this.value).toString();
			}
		}
	}
</script>

<style lang="scss" scoped>
	.entity-select-view {
		& > input {
			display: block;
			width: 100%;
			height: 100%;
			background-color: #202127;
			color: white;
			
			&.validated {
				border-right: 5px solid #00c017;
			}

			&.validated.error {
				border-color: #f7223f;
			}
		}

		& > .edit__label {
			position: relative;
			margin-bottom: 5px;
		}
	}
</style>